var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVerified && _vm.isApproved)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-icon',_vm._g(_vm._b({staticClass:"verification-badge",style:({ fontSize: _vm.iconSize }),attrs:{"small":"","color":_vm.iconColor}},'v-icon',attrs,false),on),[_vm._v(" mdi-check-circle ")])]}}],null,false,2924462778)},[_c('span',[_vm._v("Usuario Verificado")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }